import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PixelAddScreen from "./components/pixelAddScreen";
import PixelScreen from "./components/pixelScreen";
import InstallPage from "./components/InstallPage";
import PlanViewPage from './components/PlanViewPage';
import UpdateChargePage from './components/UpdateChargePage';
import ShopifyCallback from "./components/ShopifyCallback";
import Settings from "./components/Setting";
import GoogleAdsTracking from "./components/GoogleAdsTracking";
import AdGooglePixelSetting from "./components/AdGooglePixelSetting";
import GoogleTabs from "./components/GoogleTabs";
import GoogleAuth from "./components/GoogleAuth";
import '@shopify/polaris/build/esm/styles.css';
function App() {
  return (
    <Router>
      <Routes>
	        <Route path="/shopify/plan_view" element={<PlanViewPage />} />
        <Route path="/shopify/callback" element={<ShopifyCallback />} />
        <Route path="/shopify/install" element={<InstallPage />} />
		<Route path="/shopify/updateCharge" element={<UpdateChargePage />} />
        <Route path="/pixels" element={<PixelScreen />} />
        <Route path="/add/pixel" element={<PixelAddScreen />} />
        <Route path="/google-adds-tracking" element={<GoogleAdsTracking />} />
			    <Route path="/auth" element={<GoogleAuth />} />
    <Route path="/callback" element={<GoogleAuth />} />
        <Route
          path="/google-adds-tracking-setting"
          element={<AdGooglePixelSetting />}
        />
        <Route
          path="/shopify/app_view"
          element={<GoogleTabs />}
        />
      </Routes>
    </Router>
  );
}

export default App;
